import { render, staticRenderFns } from "./Solicitudes.vue?vue&type=template&id=66d155fc&"
import script from "./Solicitudes.vue?vue&type=script&lang=ts&"
export * from "./Solicitudes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports